import { Autocomplete, Chip, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

interface IBrand {
  id: number
  name: string
}

export function UserBrandAutocomplete({ user, userSelected, handleInputChange }: any) {

  const { t } = useTranslation(['global'])
  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleMultiAutoCompleteChange = (brands: IBrand[]) => {
    let optionsMulti: number[] = []
    if (brands !== null) {
      for (let i = 0; i < brands.length; i++) {
        optionsMulti.push(brands[i].id)
      }
    }

    handleInputChange('brands', optionsMulti)
  }

  const isEditing = userSelected !== null && user.id !== 0

  const getAutocompleteValue = () => {

    if (!isEditing && (!user.brands || user.brands.length === 0)) {
      return []
    }

    return userBrands.filter((brand: IBrand) =>
      Array.isArray(user.brands) && user.brands.includes(brand.id)
    )
  }

  return (
    <Autocomplete<IBrand, true, false, false>
      id="multi-autocomplete-brands"
      ChipProps={{ color: 'secondary' }}
      value={getAutocompleteValue()}
      onChange={(_, value) => handleMultiAutoCompleteChange(value)}
      options={userBrands as IBrand[]}
      multiple
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disabled={
        isEditing
          ? ([3, 4, 6, 8, 9].includes(authUser.role_id) && authUser.id === user.id) ||
          ([4, 8, 9].includes(authUser.role_id) && user.role_id === 6)
          : false
      }
      getOptionLabel={(option: IBrand) => (option?.id !== undefined ? option.name : '')}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            label={option.name}
            {...getTagProps({ index })}
            disabled={
              isEditing &&
              (
                (userSelected?.permissions?.notEditBrands ?? []).includes(option.id) ||
                ([3, 4, 6, 8, 9].includes(authUser.role_id) && authUser.id === user.id) ||
                ([4, 8, 9].includes(authUser.role_id) && user.role_id === 6)
              )
            }
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          required
          label={t('brands')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.brands}
          helperText={msgForm.brands}
        />
      )}
    />
  )
}
